module.exports = __webpack_public_path__ + "img/ienvo.2be91c2a.png";